import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';
import { T as TrackingService } from './index3.js';
import { A as AdobeTracking } from './index7.js';
import { t as toString } from './toString.js';

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

const rocheOffcanvasTriggerCss = "roche-offcanvas-trigger{display:inline}";
const RocheOffcanvasTriggerStyle0 = rocheOffcanvasTriggerCss;

const RocheOffcanvasTrigger = /*@__PURE__*/ proxyCustomElement(class RocheOffcanvasTrigger extends HTMLElement {
    static trigger(id, triggerId) {
        window.dispatchEvent(new CustomEvent('rocheOffcanvasTrigger', { detail: { offcanvasId: id, triggerId } }));
    }
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: this.trackingEventName,
            component_name: 'roche-offcanvas-trigger',
        };
    }
    // eslint-disable-next-line class-methods-use-this
    get adobeTracking() {
        return {
            name: 'Hamburger Button',
            innerText: '',
            url: '',
            position: 'Top Navigation',
            type: 'Button',
            socialMedia: '',
            socialInteraction: '',
        };
    }
    constructor() {
        super();
        this.__registerHost();
        this.offcanvasId = undefined;
        this.trackingEventName = 'offcanvas_trigger';
        this.triggerId = uniqueId();
    }
    handleTrigger() {
        RocheOffcanvasTrigger.trigger(this.offcanvasId, this.triggerId);
        AdobeTracking(this.adobeTracking, 'defaultLinkClick');
    }
    handleClose({ detail }) {
        if (this.offcanvasId !== detail.offcanvasId || this.triggerId !== detail.triggerId) {
            return;
        }
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), { value: detail.state, additionalParameters: {
                offcanvasId: this.offcanvasId.split('-')[2],
            } }));
    }
    static get style() { return RocheOffcanvasTriggerStyle0; }
}, [0, "roche-offcanvas-trigger", {
        "offcanvasId": [1, "offcanvas-id"],
        "trackingEventName": [1, "tracking-event-name"]
    }, [[0, "click", "handleTrigger"], [8, "rocheOffcanvasVisibilityChange", "handleClose"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-offcanvas-trigger"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-offcanvas-trigger":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheOffcanvasTrigger);
            }
            break;
    } });
}

export { RocheOffcanvasTrigger as R, defineCustomElement as d };

//# sourceMappingURL=roche-offcanvas-trigger2.js.map